// extracted by mini-css-extract-plugin
export var bounce = "FeaturedQuote-module--bounce--f25f0";
export var dotMoveLeft = "FeaturedQuote-module--dot-move-left--e330c";
export var dotMoveRight = "FeaturedQuote-module--dot-move-right--5a748";
export var gradient = "FeaturedQuote-module--gradient--e9c97";
export var quote = "FeaturedQuote-module--quote--e05a7";
export var separatorWidth = "FeaturedQuote-module--separator-width--501d7";